import { FC } from 'react';
import { Alert, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ReminderAlertProps {
	open: boolean;
	onClose: () => void;
	text: string;
}

export const ReminderAlert: FC<ReminderAlertProps> = ({ open, onClose, text }) => {
	if (!open) return null;

	return (
		<Box
			sx={{
				position: 'absolute',
				top: '100%',
				right: 0,
				zIndex: 10,
				mt: 2.5,
				width: '280px',
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: -20,
					right: 40,
					width: 0,
					height: 0,
					borderLeft: '10px solid transparent',
					borderRight: '10px solid transparent',
					borderBottom: '20px solid #e7af02',
					// animation: 'bounce 2s infinite',
					// '@keyframes bounce': {
					// 	'0%, 100%': { transform: 'translateY(0)' },
					// 	'50%': { transform: 'translateY(-10px)' },
					// },
				}}
			/>
			<Alert
				severity="warning"
				variant="filled"
				sx={{
					boxShadow: 3,
					animation: 'pulse 1.5s infinite',
					'@keyframes pulse': {
						'0%': { boxShadow: '0 0 0 0 #e7af02b0' },
						'70%': { boxShadow: '0 0 0 10px rgba(0, 67, 102, 0)' },
						'100%': { boxShadow: '0 0 0 0 rgba(0, 67, 102, 0)' },
					},
				}}
				action={
					<IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
						<CloseIcon fontSize="inherit" />
					</IconButton>
				}
			>
				{text}
			</Alert>
		</Box>
	);
};
